import { MigrateStatus } from '~/services';

export const flatten = (array: any[]) => {
  // flatten arrays inside the supplied array and
  // remove duplicates from the result
  return array
    .reduce((acc: any, val: any) => acc.concat(val), [])
    .filter((elem: any, pos: number, arr: any) => arr.indexOf(elem) === pos);
};

export const dedupe = (array: any[]) => {
  if (!Array.isArray(array)) return array;
  // remove duplicates from simple array
  return array.filter(
    (elem: any, pos: number, arr: any) => arr.indexOf(elem) === pos
  );
};

export const dedupeInner = (array: any[]) => {
  const stringArray = array.map((itm) => JSON.stringify(itm));
  const uniqueStringArray = new Set(stringArray);
  const uniqueArray = Array.from(uniqueStringArray).map((itm) =>
    JSON.parse(itm)
  );
  return uniqueArray;
};

/**
 * Callback for Array.sort() to sort an object array
 * alphabetically by the value of a given key
 */
export const sortByStringInKey =
  <T extends Record<string, any>>(key = 'id') =>
  (a: T, b: T) =>
    a[key].localeCompare(b[key]);

export const sortStatuses = {
  error: 0,
  'not found': 0,
  delete: 100,
  update: 200,
  'two-pass': 300,
  create: 400,
  'no change': 500,
} as { [key in MigrateStatus]: number };

/** Sort an array of resources containing a migrate status
 * in a special order defined in sortStatuses */
export const sortByStatus = (statusA: any, statusB: any) => {
  if (
    sortStatuses[statusA as MigrateStatus] ===
    sortStatuses[statusB as MigrateStatus]
  )
    return 0;

  return (
    sortStatuses[statusA as MigrateStatus] -
    sortStatuses[statusB as MigrateStatus]
  );
};

/** Update or push an item in an array, filtering an existing item
 * out of the array by id or the key provided and pushing the replaceItem
 * to the end of the array */
export const replaceItemByKey = (arr: any[], replaceItem: any, key = 'id') => {
  arr = arr.filter((item) => item[key] !== replaceItem[key]);
  arr.push(replaceItem);
  return arr;
};

/** Update an array with another, filtering any existing items
 * out of the array by id and pushing the new items
 * to the end of the array */
export const replaceItemsById = (arr: any[], replaceItems: any[]) => {
  for (const replaceItem of replaceItems) {
    arr = replaceItemByKey(arr, replaceItem, 'id');
  }
  return arr;
};
